export const MAX_IMAGE_COUNT = 9;
